import React from 'react';
import Helmet from 'react-helmet';

import siteData from '../services/siteData';
import Jumbotron from '../components/Jumbotron';

export default class DirectorsPage extends React.PureComponent {
  componentDidMount() {
    document.documentElement.classList.add('directors');
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('directors');
  }

  render() {
    return (
      <>
        <Helmet>
          <title>{`Directors - ${siteData.title}`}</title>
          <meta name="theme-color" content="#ffdddd" />
        </Helmet>
        <Jumbotron
          variant="directors"
          title="Pink Monkey"
          text="Coming soon"
        />
      </>
    );
  }
}
